import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Popover } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import { useContext, useState } from 'react'
import { mediaURL } from 'src/consumer/services'
import styled from 'styled-components'
import { BusinessProfileContext } from '../context/BusinessProfileContext'

import { Link, useNavigate } from 'react-router-dom'
import { logoutHandlerBusiness } from '../helpers/helperFunctions'
import { GenericDisplayFlexColumn } from '../layout/styledComponents'
import { AppHeaderDropdownNotif } from './header'
import { ProfileHeader } from './styledComponents'
import PortalSwitcherButton from './header/PortalSwitcherButton'

export const BusinessAppHeaderParent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  justify-content: space-between;
  align-items: stretch;
  padding: 0 12px;
  gap: 10px;
  min-width: 0;

  @media (min-width: 480px) {
    padding: 0 16px;
  }
  @media (min-width: 600px) {
    flex-direction: row;
    align-items: center;
    padding: 0 24px;
    gap: 0;
  }
`

export const ProfileRelatedWidgetContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: ${({ themeType }) =>
    themeType === 'dark' ? 'rgba(55, 56, 61, 0.8)' : 'rgba(227, 235, 255, 0.7)'};
  backdrop-filter: blur(8px);
  border: 1px solid ${({ themeType }) =>
    themeType === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(32, 7, 105, 0.08)'};
  border-radius: 12px;
  padding: 10px 12px;
  gap: 8px;
  width: 100%;
  min-width: 0;
  transition: background 0.2s ease, border-color 0.2s ease;

  @media (min-width: 480px) {
    padding: 12px 14px;
    gap: 10px;
    border-radius: 14px;
  }
  @media (min-width: 600px) {
    width: auto;
    padding: 12px 16px;
    border-radius: 16px;
  }

  @media (min-width: 800px) {
    padding: 14px 20px;
    gap: 12px;
  }
  @media (min-width: 1300px) {
    padding: 16px 24px;
    gap: 14px;
  }
`

export const BusinessProfileDropdownMenuOptionContainer = styled.div`
  min-width: 165px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: start;
  font-family: Outfit;
  padding: 8px 5px;
  border-radius: 7px;
  cursor: pointer;
  color: #313233;
  font-weight: 500;
  font-size: 18px;
  &:hover {
    background: #e7edf1;
  }
`

export const CompanyDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;

  .text-textHeading,
  .font-bold {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

//// components :

export const ProfileRelatedWidget = ({ themeType }) => {
  const { profileData, businessCustomerDetails, businessCustomerPersonalDetails } =
    useContext(BusinessProfileContext)
  const [anchorElProfileDropdown, setAnchorElProfileDropdown] = useState()
  const profileDropdownOpen = Boolean(anchorElProfileDropdown)

  const handleProfileDropdownPopoverClosed = () => {
    setAnchorElProfileDropdown(null)
  }

  const navigate = useNavigate()

  return (
    <ProfileRelatedWidgetContainer themeType={themeType}>
      {/* <ThemeToggle /> */}

      <AppHeaderDropdownNotif />

      <PortalSwitcherButton />

      <Avatar
        name={businessCustomerPersonalDetails?.name}
        src={`${mediaURL}${businessCustomerPersonalDetails?.profilePicId}`}
        size="50"
        round={true}
        onClick={(event) => setAnchorElProfileDropdown(event.currentTarget)}
      />
      <GenericDisplayFlexColumn>
        <ProfileHeader className="font-bold text-gray-900 dark:text-white">
          {businessCustomerPersonalDetails?.name}
        </ProfileHeader>
        <span className="text-gray-400">{businessCustomerPersonalDetails?.designation}</span>
      </GenericDisplayFlexColumn>

      <Popover
        id="booked-slots-popover"
        open={profileDropdownOpen}
        anchorEl={anchorElProfileDropdown}
        onClose={handleProfileDropdownPopoverClosed}
        PaperProps={{ sx: { mt: 1 } }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div style={{ padding: '10px' }}>
          <Link to="/workplace/profile" style={{ textDecoration: 'none' }}>
            <BusinessProfileDropdownMenuOptionContainer>
              <img alt="profile.png" style={{ height: '22px' }} src="profile.png" />
              Profile
            </BusinessProfileDropdownMenuOptionContainer>
          </Link>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <BusinessProfileDropdownMenuOptionContainer>
              <ArrowBackIcon sx={{ fontSize: 20, color: 'gray' }} />
              Switch to consumer view
            </BusinessProfileDropdownMenuOptionContainer>
          </Link>
          <BusinessProfileDropdownMenuOptionContainer
            onClick={() => {
              logoutHandlerBusiness()
              navigate('/')
            }}
          >
            <img alt="logout.png" style={{ height: '22px' }} src="logout.png" />
            Logout
          </BusinessProfileDropdownMenuOptionContainer>
        </div>
      </Popover>
    </ProfileRelatedWidgetContainer>
  )
}
